<template>
<div class="offerdetail">
  <div v-if="current">
    <heading>Status</heading>
    <p class="offerdetail__content"><span class="is-capitalized">{{current.jobOfferStatus}}</span></p>
    <divider />
    <heading>Role</heading>
    <job-row-card class="hoverable" :job="job" @click="onJobClicked"/>
    <divider />
    <heading>Applicant</heading>
    <user-row-card class="hoverable" :user="user" @click="onUserClicked" />
    <div v-if="referrer">
      <divider />
      <heading>Referrer</heading>
      <user-row-card class="hoverable" :user="referrer" @click="onUserClicked(current.referrerId)" />
    </div>
    <div v-if="submittedBy">
      <divider />
      <heading>Submitted By</heading>
      <user-row-card class="hoverable" :user="submittedBy" @click="onUserClicked(current.userId)" />
    </div>
    <divider />
    <heading>Agreed salary</heading>
    <p>${{ salary.toLocaleString() }}</p>
    <divider />
    <heading>Start date</heading>
    <p>{{ current.jobOfferStatrtDate | formatDate }}</p>
    <divider />
    <heading>Total Cost</heading>
    <p class="offerdetail__content">If the applicant accepts your job offer of ${{ salary.toLocaleString() }}, your total HireVibes invoice, to be paid in USD, will cost:</p>
    <div class="hvt-reward">
      <h1 class="title m-b-8">
        ${{ invoice.toLocaleString() }}
      </h1>
    </div>
  </div>
</div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import UserRowCard from '@/components/general/user-row-card'
import JobRowCard from '@/components/jobs/job-row-card'
import Heading from '@/components/general/heading'
import Divider from '@/components/general/divider'
import TextView from '@/components/general/text-view'
import RewardHelper from '@/helpers/reward'
import Users from '@/api/users'
import _ from 'lodash'
import moment from 'moment'

export default {
  components: {
    UserRowCard, JobRowCard, Heading, Divider, TextView
  },
  computed: {
    ...mapState('adminApplications', [
      'current',
      'currentOfferSalary',
      'currentOfferStartDate',
      'currentPrice'
    ]),
    ...mapGetters('adminApplications', [
      'canMakeOffer',
      'hvtReward'
    ]),
    tokenPrice () {
      return Number(this.currentPrice).toFixed(4)
    },
    job () {
      return {
        title: this.current.jobTitle,
        salary: this.current.jobSalary,
        companyName: this.current.jobCompany,
        locations: this.current.jobLocations,
        companyImageUrl: this.current.jobCompanyImageUrl,
        contract: this.current.jobContract
      }
    },
    user () {
      return {
        id: this.current.userId,
        firstName: this.current.applicantFirstName,
        lastName: this.current.applicantLastName,
        profilePictureUrl: this.current.applicantProfilePictureUrl,
        location: this.current.applicantLocation,
        companyName: this.current.applicantCompanyName,
        role: this.current.applicantRole
      }
    },
    referrer () {
      if (this.current.referrerId) {
        return {
          id: this.current.referrerId,
          firstName: this.current.referrerFirstName,
          lastName: this.current.referrerLastName,
          profilePictureUrl: this.current.referrerProfilePictureUrl,
          location: this.current.referrerLocation,
          companyName: this.current.referrerCompanyName,
          role: this.current.referrerRole
        }
      }
      return null
    },
    salary () {
      return (this.current.jobOfferSalary * 1)
    },
    invoice () {
      return RewardHelper.totalReward(this.salary, this.current.rewardPercentage)
    }
  },
  filters: {
    capitalize (value) {
      return _.capitalize(value)
    },
    formatDate (value) {
      return moment(value).format('DD MMM YY')
    }
  },
  methods: {
    onJobClicked () {
      const jobId = this.current.jobId
      window.open(`/jobs/${jobId}`, '_blank')
    },
    onUserClicked () {
      const jobseekerId = this.current.userId
      window.open(`/jobseekers/${jobseekerId}`, '_blank')
    },
    async sumittedBy () {
      if (!this.current) return
      if (this.current.registrarId) {
        try {
          const u = await Users.getByAccountId(this.current.registrarId)
          if (u) {
            u.location = u.locationTitle
            this.submittedBy = u
          }
        } catch (err) {
          //
        }
      }
    }
  },
  data () {
    return {
      submittedBy: null
    }
  },
  watch: {
    current: {
      deep: true,
      handler: async function (newVal) {
        if (newVal) {
          await this.sumittedBy()
        }
      }
    }
  },
  async mounted () {
    await this.sumittedBy()
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/defaults.scss';

.offerdetail {
    &__content {
        line-height: 21px;
    }
    .hvt-reward {
        text-align: center;
    }
    .hvt-reward {
        width: 100%;
        display: flex;
        align-items: center;
        padding-top: 1.5rem;
        flex-direction: column;

        font-size: 0.75rem;

        .title {
            font-size: 1.5rem;
            color: $black;
            font-weight: bold;
        }
    }
}

.hoverable:hover {
  cursor: pointer;
  background-color: $hover-background;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/applications/offer-detail.vue